import { Texts } from '../../../../hooks/useTexts'

const companyNameMaxLength = 30

export const createValidateCompanyName = async (texts: Texts, companyName: string) => {
  const companyNameMaxLengthError = {
    id: 'companyNameMaxLengthError',
    field: 'companyName',
    message: texts.validations.companyNameMaxLength(companyNameMaxLength),
  }

  const invalid = companyName.length > companyNameMaxLength

  return {
    [companyNameMaxLengthError.id]: invalid ? companyNameMaxLengthError : undefined,
  }
}
